export default __webpack_public_path__ + "static/media/plain-sticker-Z.71ec34a7.png";